const data = [
    [0, 5, 'Hej '],
    [6, 8, 'God morgon '],
    [9, 10, 'God förmiddag '],
    [11, 14, 'God middag '],
    [15, 17, 'God eftermiddag '],
    [18, 23, 'God kväll '],
];

export const displayGreeting = (firstName: string): string => {
    const dateHourNow = new Date().getHours();
    let result;
    for (let i = 0; i < data.length; i++) {
        if (dateHourNow >= data[i][0] && dateHourNow <= data[i][1]) {
            result = data[i][2];
        }
    }
    if (!result) result = "Hej ";
    return result + firstName + "!";
}